<template>
	<div class="box">
		<div class="row align-items-end">
			<div class="col-12 col-md-4 mb-2">
				<label>{{ $t('monte.congelation.centre_congelation') }}</label>
				<e-select
					id="campagne_centre"
					track-by="tiers_id"
					label="tiers_rs"
					:placeholder="$t('monte.congelation.selectionner_centre')"
					:options="all_centres"
					:searchable="true"
					:show-labels="false"
					:multiple="true"
					v-model="centres"
				>
					<template slot="option" slot-scope="{ option }">{{ option.tiers_rs }} <template v-if="option.numero">({{ option.numero }})</template></template>
					<template slot="singleLabel" slot-scope="{ option }">{{ option.tiers_rs }} <template v-if="option.numero">({{ option.numero }})</template></template>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-12 col-md-auto mb-2">
				<DateRangeV2
	                class="mb-md-0"
	                :submitButtonMobile="true"
	                :start.sync="start_date"
	                :end.sync="end_date"
	                :dateSelect="true"
	                :periodToShow="['personalise','jour','mois','mois_dernier']"
	                @submit="load_statistiques"
	            />
			</div>
		</div>
		<CustomTable
			ref="table"
			id_table="congelation_statistiques"
			:items="statistiques"
			primaryKey="horse_id"
			:busy.sync="table_busy"
            :hrefsRoutes="config_table_hrefs"
            :externSlotColumns="['proprietaires']"
		>
			<template v-slot:[`custom-slot-cell(proprietaires)`]="{ data }">
				<router-link v-for="tiers in data.proprietaires" :key="tiers.tiers_id" :to="{ name: 'tiersFiche', params: { tiers_id: tiers.tiers_id }}">
                    {{ tiers.tiers_rs }}<br>
                </router-link>
			</template>
		</CustomTable>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'StatistiquesProduction',
		mixins: [Congelation],
		data () {
			return {
				start_date: new Date(new Date().setMonth(new Date().getMonth() - 3)),
				end_date: new Date(),
				all_centres: [],
				centres: [],
				table_busy: false,
				statistiques: [],
				config_table_hrefs: {
					'horse_nom': {
						routeUniqueName: 'StallionFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'horse_id'
						}
					},
					'centre_rs': {
						routeUniqueName: 'centreFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'centre_id'
						}
					},
				}
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.all_centres = await this.loadCentreCollecte()
				if(this.all_centres.length == 1) {
					this.centres = this.all_centres
					this.load_statistiques()
				}
			},

			async load_statistiques() {
				if(!this.start_date || !this.end_date || this.centres.length == 0) {
					return false
				}
				const centres_ids = this.centres.map(centre => centre.tiers_id).join(',')

				this.table_busy = true
				this.statistiques = await this.getStatistiqueProduction(centres_ids, this.start_date.toDateInputValue(), this.end_date.toDateInputValue())
				this.table_busy = false
			}
		},

		components: {
	        DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable')
		}
	}

</script>